import React, { useEffect, useRef } from 'react';
import './index.scss';

const SortModel = (props) => {
  const sortMenuRef = useRef(null);

  // Function to handle clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Prevent closing if clicked inside .arrow-container
      if (
        sortMenuRef.current &&
        !sortMenuRef.current.contains(event.target) &&
        !event.target.closest('.arrow-container') // Ignore clicks inside .arrow-container
      ) {
        props.closeSortMenu();
      }
    };

    // Attach event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Cleanup event listener on unmount
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [props.closeSortMenu]);

  let huntOptions = [
    { label: 'Alphabatical', value: 'apply_for' },
    { label: 'Points to Draw (low)', value: 'min_point_point_asc' },
    { label: 'Points to Draw (high)', value: 'min_point_point_desc' },
    { label: 'Draw Odds', value: 'min_point_odds' },
    { label: 'Harvest Success', value: 'harvest_success' }
  ];

  let unitOptions = [
    { label: 'Alphabetical', value: 'geo_name' },
    { label: 'Public land %', value: 'public_land' },
    { label: 'Unit score', value: 'unit_score' },
    { label: 'Trophy Potential', value: 'trophy_potential' }
  ];

  let options = props.selectedTab === 'Units' ? unitOptions : huntOptions;

  let handleSearchInputChange = (option) => {
    if (props.selectedTab === 'Units') {
      props.filterHuntUnitList(option.value, 'Units');
      props.sortOption(option.label);
    } else {
      props.filterHuntList(option.value);
      props.sortOption(option.label);
    }
    props.closeSortMenu();
  };

  return (
    <div ref={sortMenuRef}>
      <div className='ht-sort-by-options' style={{ width: props.selectedTab === 'Units' ? '150px' : '' }}>
        <ul className='ht-ul-sort-option' style={{ listStyleType: 'none', padding: 0, width: props.selectedTab === 'Units' ? '85%' : '' }}>
          {options.map((option) => (
            <div
              key={option.value}
              style={{
                width: '100%', height: 30, display: 'flex', justifyContent: 'center', alignItems: 'center'
              }}
            >
              <div style={{ width: '17%', display: 'flex', justifyContent: 'right' }}>
                <input
                  type="radio"
                  name="sort-options"
                  className='sort-radio'
                  style={{ cursor: 'pointer', minWidth: 20, width: 20, minHeight: 20, height: 20 }}
                  checked={props.activeSelection === option.label}
                  onClick={() =>
                    props.activeSelection !== option.label && handleSearchInputChange(option)
                  }
                />

              </div>
              <div style={{ width: '83%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <p className='sort-labels'>{option.label}</p>
              </div>
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SortModel;
